<ion-header class="extendido">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title class="ion-title-icon">{{'Encontros' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content>
  <div *ngFor="let e of encontros" class="encontro-item" (click)="openEncontro(e)">
    <ion-card class="card-swiper">
      <ion-card-content class="conteudo-evento">
        <div class="data-card">
          <span class="mes">{{ e.dataInicio | dateFormat:"MMM" | uppercase }}</span>
          <span class="dia">{{ e.dataInicio | dateFormat:"dd" }}</span>
          <span class="hora">{{ e.dataInicio | dateFormat:"hora" }}</span>
        </div>

        <div class="texto-evento">
          <div class="titulo-evento">
            {{ e?.materia ? e.materia : evento.tema }}
          </div>

          <div *ngIf="e.localFisico" class="item-description">
            <i class="fa-solid fa-location-dot icon"></i>
            <p class="local">{{ e.localFisico }}</p>
          </div>
        </div>

        <div class="select">
          <i class="fa-regular fa-chevron-right"></i>
        </div>
      </ion-card-content>
    </ion-card>
  </div>

  <sem-registro *ngIf="!encontros?.length"></sem-registro>
</ion-content>